module.exports = __webpack_public_path__ + "img/left-5.8cc24c47.jpg";